import { render, staticRenderFns } from "./HealthCoachingSelectCoach.vue?vue&type=template&id=27bc5436"
import script from "./HealthCoachingSelectCoach.vue?vue&type=script&lang=js"
export * from "./HealthCoachingSelectCoach.vue?vue&type=script&lang=js"
import style0 from "./HealthCoachingSelectCoach.vue?vue&type=style&index=0&id=27bc5436&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports